import React, { useEffect, useState } from "react";
import Select from "react-select";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#1A1A1A",
    borderColor: state.isFocused ? "#F74902" : "#2D2D2D",
    boxShadow: state.isFocused ? "0 0 0 1px #F74902" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#F74902" : "#6B6B6B",
    },
    minHeight: 38,
    marginBottom: 10,
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#1A1A1A",
    border: "1px solid #2D2D2D",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "#FFFFFF" : "#E5E5E5",
    backgroundColor: state.isSelected ? "#F74902" : state.isFocused ? "#2D2D2D" : "#1A1A1A",
    padding: 10,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6B6B6B",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#FFFFFF",
  }),
  input: (provided) => ({
    ...provided,
    color: "#FFFFFF",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#6B6B6B",
    "&:hover": {
      color: "#F74902",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#6B6B6B",
    "&:hover": {
      color: "#F74902",
    },
  }),
};

function BasicDropdown({
  name,
  options,
  placeholder,
  handleChange,
  isSearchable = false,
  apiFunction = null,
  toOptionLabel = null,
  value,
}) {
  const [ddOptions, setDdOptions] = useState(options ? options : []);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiFunction) {
      getOptions();
    }
  }, []); //eslint-disable-line

  useEffect(() => {
    // Update ddOptions when options prop changes
    if (options) {
      setDdOptions(options);
    }
  }, [options]);

  const getOptions = async () => {
    setIsLoading(true);
    let response = await apiFunction();
    if (response.success) {
      const mappedOptions = response.data.map((option) => toOptionLabel(option));
      setDdOptions(mappedOptions);
    } else {
      setDdOptions([]);
    }
    setIsLoading(false);
  };

  const onSelect = (option) => {
    console.log("====================================");
    console.log(option);
    console.log("====================================");
    handleChange(option, name);
  };

  return (
    <Select
      id={name}
      options={ddOptions}
      styles={customStyles}
      placeholder={placeholder}
      isClearable={true}
      isSearchable={isSearchable}
      onChange={onSelect}
      value={value}
      isLoading={isLoading}
    />
  );
}

export default BasicDropdown;
